import { fetchAllBlogPosts } from './BlogPost';

export const getRelatedBlogs = async () => {
    return fetchAllBlogPosts();
};

export const RelatedBlogs = [];
